module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" xml:space=\"preserve\"><path d=\"M23.5,6.1L4.4,25.1c-1.2,1.2-1.9,2.9-1.9,4.7c0,1.7,0.7,3.4,1.9,4.7l19.1,19.1c2.6,2.6,6.7,2.6,9.3,0 c2.6-2.6,2.6-6.7,0-9.3L25,36.3h44.6c8.2,0,14.8,6.6,14.8,14.8v16.8c0,8.2-6.6,14.8-14.8,14.8H9.1c-3.6,0-6.6,2.9-6.6,6.6 c0,3.6,2.9,6.6,6.6,6.6h60.5c15.4,0,27.9-12.5,27.9-27.9V51.1c0-15.4-12.5-27.9-27.9-27.9H25l7.8-7.8c1.3-1.3,1.9-3,1.9-4.7 c0-1.7-0.6-3.4-1.9-4.7C30.2,3.5,26.1,3.5,23.5,6.1z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./frontend/images/icons/refund.svg
// module id = 541
// module chunks = 0